import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Projectcomment } from '@src/app/models/comment';
import { Project } from '@src/app/models/project';
import { Task } from '@src/app/models/task';

@Injectable({
  providedIn: 'root'
})
export class ProjecttaskService {

  constructor(private http:HttpClient) { }
  taskDone(task:Task){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+task.projectId+'/task/'+task.taskId,task,httpOptions);
  }
  taskUndone(task:Task){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+task.projectId+'/task/'+task.taskId,task,httpOptions);
  }
  saveTask(task:Task){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+task.projectId+'/task/'+task.taskId,task,httpOptions);
  }
  deleteTask(task:Task){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+task.projectId+'/task/'+task.taskId,httpOptions);
  }
  saveComment(comment:Projectcomment){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //POST	/project/{projectId}/comment
    return this.http.post<string>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+comment.projectId+'/comment',JSON.stringify(comment),httpOptions)
  }
  generateStats(projectId){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    try{
      return this.http.post<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+'/stats/overview','{"msg":"No body"}',httpOptions);
     
      }catch(error) {
        console.error(error);
      }
      
     }
  getProject(projectId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Project>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId,httpOptions);
  }
}
